import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { StyleManagerService } from "./style-manager.service";

@Injectable({ providedIn: 'root' })
export class EngageThemeService {
  constructor(private http: HttpClient,
    private styleManager: StyleManagerService
  ) { }

  setTheme(themeToSet) {
    this.styleManager.setStyle(
      "theme",
      `assets/css/${themeToSet}.css`
    );
  }
}
